import React, { useEffect } from "react";
import { ReactComponent as ArrowRight } from "assets/icons/arrow_long_right.svg";
import { useOrganiseList } from "context/OrganiseListContext";
import { useNavigate } from "react-router";
import useAuth from "hooks/useAuth";

const RecentEditedLists = () => {
  const {
    fetchRecentlyModifiedOrganiseList,
    recetnlyModifiedOrganiseLists,
    handleSelectOrganiseList,
  } = useOrganiseList();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchRecentlyModifiedOrganiseList();
  }, [user]);

  if (recetnlyModifiedOrganiseLists?.length < 1) return;

  const handleClickList = (list) => {
    const { _id, name, color, emoji } = list;

    handleSelectOrganiseList({
      _id,
      name,
      color,
      emoji,
    });
    window.scrollTo(0, 0);
    navigate("/organizer");
  };

  return (
    <div className="bg-white rounded-[15px] h-[566px] pt-[18px] px-[20px] pb-[21px] w-full">
      <h1 className="text-[22px] leading-[30px] font-semibold text-black">
        Le liste che hai modificato più recentemente
      </h1>
      <div className="bg-[#F4F4F4] rounded-[7px] mt-5 py-5 h-[calc(100%-80px)] px-[10px] space-y-5">
        {recetnlyModifiedOrganiseLists.map((list) => (
          <div
            key={list._id}
            onClick={() => handleClickList(list)}
            className="border-b border-[#D7D7D7] h-[120px]"
          >
            <div className="pr-[3px]">
              <div className="flex space-x-[10px] items-center">
                <div
                  style={{ background: list?.color }}
                  className="flex-shrink-0 w-[52px] h-[52px] text-2xl rounded-full flex items-center justify-center"
                >
                  {list?.emoji}
                </div>
                <h1 className="text-[15px] leading-[30px] font-medium">
                  {list?.name}
                </h1>
              </div>
              <div className="mt-3 flex justify-between items-center">
                <div className="flex items-center space-x-2">
                  <button className="bg-white border rounded-[5px] border-[#D1D1D1] px-4 h-10 text-black text-[14px] font-medium">
                    {list?.bookmarks?.length + list?.externalProperties?.length}{" "}
                    Proprietà
                  </button>
                </div>
                <div className="bg-primary rounded-[7px] w-[44px] h-10 flex cursor-pointer items-center justify-center">
                  <ArrowRight className="text-white" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentEditedLists;
